<template>
<div>
<ContentHeader title="Soru Listesi Hesaplaması"  url="QuestionlistCalculations" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>


<div class="mt-4">

<span>alt puan</span> 
<InputNumber v-model="item.lowerlimit" mode="decimal" :minFractionDigits="0" :maxFractionDigits="10" @change="pointLimitEntered" class="p-inputtext-sm ml-2"/>
<span class="ml-2"> ve üst puan</span> 
<InputNumber v-model="item.upperlimit" mode="decimal" :minFractionDigits="0" :maxFractionDigits="10" @input="pointLimitEntered" class="p-inputtext-sm ml-2"/>
<span class="ml-2" > ise,</span> 


  <Dropdown  v-model="item.customattribute_id" :options="customattibutes" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="customAttributeSelected"/>
  <span class="ml-2" > özel niteliği değeri </span> 

  


  <Dropdown v-if="selectedattribute && selectedattribute.type=='select'" v-model="item.customattributeoption_id" :options="selectedattribute.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="conditionSet"/>

  <Dropdown v-if="selectedattribute && selectedattribute.type=='boolean'" v-model="item.customattribute_numeric_val" :options="booleanoptions" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @input="conditionSet"/>

  <InputText  v-if="selectedattribute && selectedattribute.type=='string'" v-model="item.customattribute_text_val" class="p-inputtext-sm ml-2"  @input="conditionSet"/>

  <template v-if="selectedattribute && selectedattribute.type=='number'">
      <Dropdown :filter="true"  v-model="item.comparison_type" :options="comparison_types" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm"  @change="comparisonTypeSelected" />

    <template v-if="item.comparison_type=='value'">
      <InputNumber   v-model="item.customattribute_numeric_val" mode="decimal" :minFractionDigits="0" :maxFractionDigits="10" @input="conditionSet" class="p-inputtext-sm ml-2"/>
    </template>
    
  
  </template>

  
  <span class="ml-2" v-if="is_conditionset"> olarak güncelle </span>



</div>

<div class="flex align-items-center justify-content-end mb-6 mt-4">

<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="submit" @click="submit"></Button>
</div>

</div>	
</template>

<script>
export default {

  name: 'QuestionlistCalculation',

  data () {
    return {
      loading:true,
      item:{
        id:null,
        upperlimit:null,
        lowerlimit:null,
        customattribute_id:null,
        customattributeoption_id:null,
        customattribute_text_val:null,
        customattribute_numeric_val:null,
        comparison_type:null,
      },
      booleanoptions:[
      {name:"Açık",id:1},
      {name:"Kapalı",id:0},
      ],
      selectedattribute:null,
      is_conditionset:false,
      customattibutes:[],
      comparison_types:[
      {name:"Aşama Puanı",code:"questionlist_points"},
      {name:"Tam Değer",code:"value"},
      ],
      lowerlimit:0,
      upperlimit:0,
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    comparisonTypeSelected()
    {
      if(this.item.comparison_type=="questionlist_points")
      {
        this.is_conditionset = true
      }
    },
    async getData()
    {
      this.loading = await true
      this.customattibutes =  await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$store.state.questionlists.questionlist.brand_id)
      this.item.upperlimit = await this.$store.state.questionlists.questionlist.limitscore
      if(this.$route.params.calculation_id)
      {
        this.item = await this.generalApiGetWithoutLoader("questionlistcalculation/"+this.$route.params.calculation_id)
        this.selectedattribute = await this.customattibutes.find((item)=>{return item.id == this.item.customattribute_id})
        this.is_conditionset = await true
      }
      await console.log(this.customattibutes)
      this.loading = await false
    },
    pointLimitEntered()
    {
      this.is_conditionset = false
    },
    customAttributeSelected()
    {
      this.is_conditionset = false
      this.selectedattribute = this.customattibutes.find((item)=>{return item.id == this.item.customattribute_id})
    },
    conditionSet()
    {
      this.is_conditionset = true
    },
    submit()
    {
        let formdata = new FormData()
        formdata.append('questionlist_id', this.$store.state.questionlists.questionlist.id);
        formdata.append('data', JSON.stringify(this.item));
        if(this.$route.params.calculation_id)
        {
          console.log("update")
          this.generalSubmission(formdata,"questionlistcalculation/"+this.$route.params.calculation_id,this.afterSubmit)
        }
        else
        {
          this.generalSubmission(formdata,"questionlistcalculation",this.afterSubmit)
        }
        
    },
    afterSubmit(response)
    {
        console.log(response.data);
        this.$router.push({ name: 'QuestionlistCalculations' })
       
          
    },
  }
}
</script>

<style lang="css" scoped>
</style>